import React from 'react';
import loadable from '@loadable/component';
import Base64Deriver from 'derivers/Base64';
import { MsaOfferProduct, PlanProduct } from 'features/Products/products';
import { activateProductOnEnter } from 'features/Products/Products.helpers';
import { signupOnEnterSaga, cartAbandonerOnEnterSaga } from 'features/Signup/Signup.onenter.saga';
import runOnEnter from 'routes/helpers/runOnEnter';

const SignupContainer = loadable(() => import('./SignupContainer'));
const CartAbandoner = loadable(() => import('./CartAbandoner'));

export const SignupRoute = (store, client) => {
  const bounceToPurchaseIfLoggedIn = (nextState, replaceState, cb) =>
    store
      .runSagaOnce(signupOnEnterSaga, client, nextState, replaceState)
      .toPromise()
      .then(cb, cb);

  const cartAbandonerOnEnter = (nextState, replaceState, cb) =>
    store
      .runSagaOnce(cartAbandonerOnEnterSaga, client, nextState, replaceState)
      .toPromise()
      .then(cb, cb);

  return {
    path: 'signup',

    onEnter: ({ location }, replaceState) => {
      if (/\/signup\/?$/.test(location.pathname)) {
        replaceState('/');
      }
    },

    childRoutes: [
      {
        path: 'continue',
        component: props => <CartAbandoner {...props} />,
        onEnter: cartAbandonerOnEnter,
      },
      {
        path: 'offer/:encodedMsaOfferId',
        component: props => <SignupContainer {...props} />,
        onEnter: runOnEnter(
          bounceToPurchaseIfLoggedIn,
          activateProductOnEnter(store, MsaOfferProduct, params => ({
            msaOfferId: Base64Deriver.decodeNumber(params.encodedMsaOfferId),
          }))
        ),
      },
      {
        path: 'plan/:encodedPlanId',
        component: props => <SignupContainer {...props} />,
        onEnter: runOnEnter(
          bounceToPurchaseIfLoggedIn,
          activateProductOnEnter(store, PlanProduct, params => ({
            planId: Base64Deriver.decodeNumber(params.encodedPlanId),
          }))
        ),
      },
    ],
  };
};
